module.exports = "/_next/static/images/stich-9c6c313501612443ca3fb2b6d8ecdf13.png";